export default __webpack_public_path__ + "static/media/imgTreasureChest.94b79e79.png";